import React from "react";
import "./index.css";
const DataLoader = () => {
  return <div className="loader"></div>;
};

export default DataLoader;
